import { useQuery } from '@tanstack/react-query';

import { errorHandler } from 'modules/global';

import { ITestData } from '../models';
import { getThemedTestQuiz } from '../queries';
import { topicTestsConst } from '..';

export const useThemedTestQuiz = (testId: string | string[] | undefined) =>
  useQuery<ITestData>({
    queryKey: [topicTestsConst.queryKeys.USE_TOPIC_TEST_QUIZ, testId],
    queryFn: () => getThemedTestQuiz(testId),
    enabled: !!testId,
    onError: errorHandler()
  });
